/*
 * jQuery Highlight plugin
 *
 *
 * Based on highlight v3 by Johann Burkard
 * http://johannburkard.de/blog/programming/javascript/highlight-javascript-text-higlighting-jquery-plugin.html
 *
 * Based on refurbishment by Bartek Szopka
 * http://bartaz.github.io/sandbox.js/jquery.highlight.html
 *
 *
 * Changes:
 *
 * Version 0.5, Andreas Motl (2014)
 *  - Option to expand highlighting to whole words (wholeWords - false by default)
 *  - Option to restrict highlighting to words with minimum length (minLength - undefined by default)
 *  - Implement callback functionality to attach DOM things to the matches
 *    Inspired by jQuery highlight plugin by Fabrice Weinberg, see https://github.com/FWeinb/jqueryhighlight
 *
 * Version 0.4, Bartek Szopka (2009)
 * Code a little bit refactored and cleaned (in my humble opinion).
 * Most important changes:
 *  - has an option to highlight only entire words (wordsOnly - false by default),
 *  - has an option to be case sensitive (caseSensitive - false by default)
 *  - highlight element tag and class names can be specified in options
 *
 * Version 0.1 - 0.3, Johann Burkard (2007)
 * We're standing on the shoulders of giants.
 * Johann did the initial implementation, thanks a bunch!
 *
 *
 * Todo:
 *  - Reintegrate with Bower wrapper project by Ilya Radchenko
 *    https://github.com/knownasilya/jquery-highlight
 *
 *
 * Usage:
 *   // wrap every occurrance of text 'lorem' in content
 *   // with <span class='highlight'> (default options)
 *   $('#content').highlight('lorem');
 *
 *   // search for and highlight more terms at once
 *   // so you can save some time on traversing DOM
 *   $('#content').highlight(['lorem', 'ipsum']);
 *   $('#content').highlight('lorem ipsum');
 *
 *   // search only for entire word 'lorem'
 *   $('#content').highlight('lorem', { wordsOnly: true });
 *
 *   // search for part of word 'lorem', but highlight the whole word
 *   $('#content').highlight('rem', { wholeWords: true });
 *
 *   // don't ignore case during search of term 'lorem'
 *   $('#content').highlight('lorem', { caseSensitive: true });
 *
 *   // ignore search term 'lorem', its length is less than 6 characters
 *   $('#content').highlight('lorem', { minLength: 6 });
 *
 *   // wrap every occurrance of term 'ipsum' in content
 *   // with <em class='important'>
 *   $('#content').highlight('ipsum', { element: 'em', className: 'important' });
 *
 *   // attach DOM things to the matches
 *   $('#content').highlight('lorem', {callback: function(element) {
 *       $(element).append($('<div class="custom"/>').html("hello world"));
 *   })
 *
 *   // remove default highlight
 *   $('#content').unhighlight();
 *
 *   // remove custom highlight
 *   $('#content').unhighlight({ element: 'em', className: 'important' });
 *
 *
 * Copyright (c) 2009 Bartek Szopka
 * Copyright (c) 2014 Andreas Motl
 *
 * Licensed under MIT license.
 *
 */

jQuery.extend({
    highlight: function (node, re, nodeName, className, callback) {
        if (node.nodeType === 3) {
            var match = node.data.match(re);
            if (match) {
                var highlight = document.createElement(nodeName || 'span');
                highlight.className = className || 'highlight';
                var wordNode = node.splitText(match.index);
                wordNode.splitText(match[0].length);
                var wordClone = wordNode.cloneNode(true);
                highlight.appendChild(wordClone);
                wordNode.parentNode.replaceChild(highlight, wordNode);
                typeof(callback) === "function" && callback(highlight);
                return 1; //skip added node in parent
            }
        } else if ((node.nodeType === 1 && node.childNodes) && // only element nodes that have children
            !/(script|style)/i.test(node.tagName) && // ignore script and style nodes
            !(node.tagName === nodeName.toUpperCase() && node.className === className)) { // skip if already highlighted
            for (var i = 0; i < node.childNodes.length; i++) {
                i += jQuery.highlight(node.childNodes[i], re, nodeName, className, callback);
            }
        }
        return 0;
    }
});

jQuery.fn.unhighlight = function (options) {
    var settings = { className: 'highlight', element: 'span' };
    jQuery.extend(settings, options);

    return this.find(settings.element + "." + settings.className).each(function () {
        var parent = this.parentNode;
        parent.replaceChild(this.firstChild, this);
        parent.normalize();
    }).end();
};

jQuery.fn.highlight = function (words, options) {
    var settings = {
        className: 'highlight',
        element: 'span',
        caseSensitive: false,
        wordsOnly: false,
        wholeWords: false,
        minLength: undefined,
        callback: function () {},
    };
    jQuery.extend(settings, options);

    // convert single-string argument to array
    if (words.constructor === String) {
        words = [words];
    }

    // skip empty words
    words = jQuery.grep(words, function(word, i){
        return word != '';
    });

    // apply minLength predicate
    words = jQuery.grep(words, function(word, i) {
        return settings.minLength != undefined ? word.length >= settings.minLength : true;
    });

    // escape each word for later regex matching
    words = jQuery.map(words, function(word, i) {
        return word.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    });

    // skip highlighting when no keywords were found
    if (words.length == 0) { return this; };

    var flag = settings.caseSensitive ? "" : "i";

    // compute search pattern
    var pattern = words.join("|");

    // only match entire words
    if (settings.wordsOnly) {
        pattern = "\\b" + pattern + "\\b";

    // expand highlighting to whole word when matching a part of it
    } else if (settings.wholeWords) {
        var subpatterns = jQuery.map(words, function(word, i) {
            return "\\w*" + word + "\\w*";
        });
        pattern = subpatterns.join('|');
    }

    var re = new RegExp(pattern, flag);

    return this.each(function () {
        jQuery.highlight(this, re, settings.element, settings.className, settings.callback);
    });
};
